import React, { useState } from "react";
import classNames from "classnames";
import { useTranslation } from "react-i18next";

import { Checkbox } from "@common/checkbox";
import { useExportData } from "@planzone/view-models";
import { ExportsDataTypes, ExportsFormats, wbsFilter } from "@planzone/dto";

import { Props } from "./types";
import { Button } from "@common/button";
import { DateTimeInput } from "@common/dateTimeInput";
import { Filters } from "./filters";
import styles from "./styles.scss";

function TaskBudgetReport(props: Props) {
  const { t } = useTranslation();
  const [filter, setFilter] = React.useState(wbsFilter);
  const [isChecked, setIsChecked] = useState(false);
  const [stopDate, setStopDate] = React.useState("");
  const { isRequestPending, exportData } = useExportData();

  return (
    <div
      className={classNames(styles.wbsReport, {
        [styles.checked]: isChecked,
      })}
    >
      <div className={styles.row}>
        <div
          className={styles.checkbox}
          onClick={() => setIsChecked(!isChecked)}
        >
          <Checkbox isChecked={isChecked} />
        </div>
        <div className={styles.col}>
          <h2 className={styles.name}>
            {t("exportReportsPage.taskBudgetReport.title")}
          </h2>
          <p className={styles.description}>
            {t("exportReportsPage.taskBudgetReport.subTitle")}
          </p>
        </div>
        {isChecked && (
          <Button
            className={styles.button}
            type="submit"
            status={isRequestPending ? "pending" : "none"}
            isDisabled={!stopDate}
            press={() => {
              exportData({
                fileName: props.fileName,
                author: props.author,
                data: {
                  type: ExportsDataTypes.TASK_BUDGET_REPORT,
                  data: {
                    planzone: props.planzone,
                    stopDate,
                    filter,
                  },
                },
                format: ExportsFormats.EXCEL,
              });
            }}
          >
            {t("exportReportsPage.download")}
          </Button>
        )}
      </div>
      {isChecked && (
        <div className={styles.filters}>
          <div className={styles.group}>
            <h3 className={styles.label}>
              {t("exportReportsPage.taskBudgetReport.stopDate")}
            </h3>
            <DateTimeInput
              dateTime={stopDate}
              placeholder={t("exportReportsPage.taskBudgetReport.stopDate")}
              input={setStopDate}
            />
          </div>
          <Filters filter={filter} setFilter={setFilter} />
        </div>
      )}
    </div>
  );
}

export { TaskBudgetReport };
